import { motion } from "framer-motion"
import React from "react"
import SignUpHeader from "@components/global/SignUpHeader/SignUpHeader"

const SupplierSignupWait = ({ stage }) => {
  let title = ""
  let intro = ""
  let login

  if (stage === "enquired") {
    title = "Thanks for your application"
    intro =
      "Thank you for your application to become our latest and greatest HOPP Supplier! Your application has been sent to one of our team, who shall be in touch very shortly to discuss your Application."
  } else if (stage === "waitlisted") {
    title = "Thanks for your application"
    intro =
      "Thank you very much for your Application. We are experiencing significantly high demand within your industry category, and as such we have put your application onto our Waiting List. We pride ourselves on being limited and exclusive to the very best suppliers in the industry, and we very much hope you will become one of our cherished members in the near future. Our team will be in touch in due course when an opening appears, or when we are seeing an increased request from users in your category."
  } else if (stage === "signedout") {
    title = "Welcome Back!"
    intro = "Please log in to continue your application"
    login = {
      text: "Log in",
      color: "pink",
    }
  } else if (stage === "admin") {
    title = "Restricted Area"
    intro = "This area is for admin users only."
  }

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <SignUpHeader title={title} content={intro} login={login} />
    </motion.div>
  )
}

export default SupplierSignupWait
